import { render, staticRenderFns } from "./CatalogRow.vue?vue&type=template&id=6b8890c9&scoped=true"
import script from "./CatalogRow.vue?vue&type=script&lang=js"
export * from "./CatalogRow.vue?vue&type=script&lang=js"
import style0 from "./CatalogRow.vue?vue&type=style&index=0&id=6b8890c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8890c9",
  null
  
)

export default component.exports